// Lightweight icon set ported from prototype (currentColor SVG strokes).
// Object map instead of switch so adding an icon is a one-line edit.

import * as React from "react";

type IconProps = {
  name: string;
  size?: number;
};

const SVG_PROPS = {
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.6,
  strokeLinecap: "round" as const,
  strokeLinejoin: "round" as const,
};

const ICONS: Record<string, React.ReactNode> = {
  "chevron-down":  <polyline points="6 9 12 15 18 9" />,
  "chevron-right": <polyline points="9 6 15 12 9 18" />,
  "chevron-left":  <polyline points="15 6 9 12 15 18" />,
  "search":        <><circle cx="11" cy="11" r="7" /><line x1="21" y1="21" x2="16.65" y2="16.65" /></>,
  "plus":          <><line x1="12" y1="5" x2="12" y2="19" /><line x1="5" y1="12" x2="19" y2="12" /></>,
  "x":             <><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></>,
  "filter":        <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" />,
  "external":      <><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" /><polyline points="15 3 21 3 21 9" /><line x1="10" y1="14" x2="21" y2="3" /></>,
  "list":          <><line x1="8" y1="6" x2="21" y2="6" /><line x1="8" y1="12" x2="21" y2="12" /><line x1="8" y1="18" x2="21" y2="18" /><line x1="3" y1="6" x2="3.01" y2="6" /><line x1="3" y1="12" x2="3.01" y2="12" /><line x1="3" y1="18" x2="3.01" y2="18" /></>,
  "timeline":      <><rect x="3" y="6" width="11" height="3" rx="1" /><rect x="7" y="11" width="13" height="3" rx="1" /><rect x="3" y="16" width="9" height="3" rx="1" /></>,
  "check":         <polyline points="20 6 9 17 4 12" />,
  "minus":         <line x1="5" y1="12" x2="19" y2="12" />,
  "edit":          <><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" /><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" /></>,
  "archive":       <><polyline points="21 8 21 21 3 21 3 8" /><rect x="1" y="3" width="22" height="5" /><line x1="10" y1="12" x2="14" y2="12" /></>,
  "download":      <><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" /><polyline points="7 10 12 15 17 10" /><line x1="12" y1="15" x2="12" y2="3" /></>,
  "calendar":<><rect x="3" y="4" width="18" height="18" rx="2" /><line x1="16" y1="2" x2="16" y2="6" /><line x1="8" y1="2" x2="8" y2="6" /><line x1="3" y1="10" x2="21" y2="10" /></>,
};

export function Icon({ name, size = 14 }: IconProps) {
  const inner = ICONS[name];
  if (!inner) return null;
  return (
    <svg width={size} height={size} {...SVG_PROPS}>
      {inner}
    </svg>
  );
}
